import api from '~/store/idonia-api/api'
import $state from '~/plugins/uploader/download-state.js'
import FILE_STATES from '~/plugins/uploader/file-states'

export default {
  name: 'file.zipped',
  background (payload, {dispatch, state}, {sha, token, socket}) {
    const {fileID, taskUUID, task_id, url} = payload
    if (task_id !== undefined || taskUUID !== undefined) {
      let params = {}
      if (sha) {
        params = {
          token: token,
          account_id: 0,
          socket_id: state.guestSockets[sha].wsID
        }
      }
      if (task_id !== '') {
        $state.updateFileState(task_id, FILE_STATES.completed)
      }
      if (url) {
        api.downloadUrl(url)
      } else {
        api.download('file/' + fileID + '/download/' + taskUUID, params)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/idonia-api/notifications/notifications/FileZipped.js